import { AlertTypes } from '../../enums/AlertTypes';

export class AlertDto {
    type: AlertTypes;
    message: string;
    id: string;
    styleClass: string;
}